import { render } from "./TransferShippingBox.vue?vue&type=template&id=a33069ba&scoped=true"
import script from "./TransferShippingBox.vue?vue&type=script&lang=js"
export * from "./TransferShippingBox.vue?vue&type=script&lang=js"

import "./TransferShippingBox.vue?vue&type=style&index=0&id=a33069ba&lang=scss&scoped=true"

import exportComponent from "../../../../../../../jiffyshirts/node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.6_vue@3.5.6_typescript@5.8.3__webpack@5.96.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a33069ba"]])

export default __exports__